import React from "react";
import { Container, Typography, Grid, Box, Chip } from "@mui/material";
import { StepCircle } from "./StyledComponents";

const StepProcessSection = ({ chipLabel, title, subtitle, steps, isDark }) => {
  return (
    <Container maxWidth="xl" sx={{ bgcolor: "background.paper" }}>
      <Container maxWidth="lg" sx={{ py: 12, pb: { xs: 5, md: 10 } }}>
        <Box textAlign="center" mb={8}>
          {chipLabel && (
            <Chip
              label={<span>{chipLabel}</span>}
              sx={{
                backgroundColor: "primary.main",
                color: "white",
                fontWeight: "600",
                fontSize: "0.8rem",
                padding: "2px 14px",
                borderRadius: "16px",
                "& .MuiChip-label": {
                  padding: "0 4px",
                },
              }}
            />
          )}
          <Typography
            gutterBottom
            sx={{
              mb: 2,
              mt: 3,
              fontWeight: "600",
              fontSize: { xs: "2rem", md: "3rem" },
            }}
          >
            {title}
          </Typography>

          <Typography
            variant="h3"
            sx={{
              fontWeight: "400",
              fontSize: { xs: "1.6rem", md: "2.4rem" },
            }}
          >
            {subtitle}
          </Typography>
        </Box>

        <Grid
          container
          spacing={8}
          alignItems="center"
          mb={8}
          sx={{ position: "relative" }}
        >
          {steps.map((step, index) => (
            <React.Fragment key={index}>
              <Grid item xs={12} md={4}>
                <Box display="flex" flexDirection="column" alignItems="center">
                  <StepCircle filled={index === 0}>{index + 1}</StepCircle>
                  <Typography
                    variant="h5"
                    component="h3"
                    gutterBottom
                    sx={{
                      textAlign: "center",
                      fontSize: "1.4rem",
                      fontWeight: "600",
                      mb: 2,
                    }}
                  >
                    {step.title}
                  </Typography>
                  <Typography
                    color="text.secondary"
                    sx={{ textAlign: "center" }}
                  >
                    {step.description}
                  </Typography>
                </Box>
              </Grid>

              {index < steps.length - 1 && (
                <Box
                  sx={{
                    display: { xs: "none", md: "block" },
                    position: "relative",
                    width: 0,
                    height: 0,
                  }}
                >
                  <Box
                    sx={{
                      display: { xs: "none", md: "flex" },
                      position: "absolute",
                      left: "33.33%",
                      top: "40%",
                      transform: "translateY(-200%)",
                      width: "60px",
                      justifyContent: "center",
                    }}
                  >
                    <img
                      src={index === 0 ? "/img/arrow.svg" : "/img/arrow2.svg"}
                      alt="Pil som pekar höger"
                      style={{ width: "100%" }}
                    />
                  </Box>
                </Box>
              )}
            </React.Fragment>
          ))}
        </Grid>
      </Container>
    </Container>
  );
};

export default StepProcessSection;
